module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || '43szohr3',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
